var map = {
	"./budgety.webp": 9740,
	"./chess.webp": 606,
	"./dicegame.webp": 789,
	"./fishhooked.webp": 224,
	"./flashback.webp": 5529,
	"./flixter.webp": 1398,
	"./grammable.webp": 8223,
	"./nomster.webp": 5874,
	"./planet-clouds.svg": 6895,
	"./planet.svg": 2029,
	"./portfolio-2020.webp": 8099,
	"./portfolio-2023.webp": 356
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2169;